class AppURL {
    static BaseURL = "https://hemisapi.nilkanthacampus.edu.np/";
    static ApplicationURL = this.BaseURL + "api/app/";
    static AcademicsURL = this.BaseURL + "api/academics/";
    static AccountsURL = this.BaseURL + "api/accounts/";
    static InventoryURL = this.BaseURL + "api/inventory/";
    static HR_URL = this.BaseURL + "api/hr/";
    static LibraryURL = this.BaseURL + "api/library/";
    static ExamURL = this.BaseURL + "api/exam/";
    static EMISRPT = this.BaseURL + "api/emis-reports/";
    static StdLMSURL = this.BaseURL + "api/student-lms/";
    static LMS = this.BaseURL + "api/lms/";
    static ugc_urls = this.BaseURL + "api/ugc/";
};

export default AppURL;
